import React, { Component } from "react";
import "./ZoomControl.scss";
import zoomIn from "./zoom-in.svg";
import zoomOut from "./zoom-out.svg";
import config from "../../config";
export default class ZoomControl extends Component {
  render() {
    const inputProps = Object.assign(
      {
        ...config.pm.zoom,
        step: 0.1,
      },
      this.props.input,
    );
    return (
      <div className="zoom-control component">
        <img src={zoomIn} alt="zoom in" />
        <input
          type="range"
          orient="vertical"
          value={this.props.zoom}
          onChange={this.props.zoomChange}
          {...inputProps}
        />
        <img src={zoomOut} alt="zoom-out" />
      </div>
    );
  }
}
